










































import Vue from 'vue'
import PageCard from '../../components/base/Page/PageCard.vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'
import BaseDescription from '../../components/base/BaseDescription.vue'

export default Vue.extend({
  name: 'Formula',
  components: { BaseDescription, TranslationDisplay, PageCard },
  props: {
    lift: {
      type: Object,
      required: true
    },
  }
})
